import { CommunityTalent } from "__generated__/graphql";
import { z } from "zod";

// Step 1: Company Information Schema
export const companyInformationSchema = z.object({
  organization: z.string().min(1, "Organization name is required"),
  roleInOrganization: z.string().min(1, "Your role is required"),
});

// Step 2: Contact Details Schema
export const contactDetailsSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().email("Please enter a valid email address"),
  phone: z.string().min(10, "Please enter a valid phone number"),
});

// Step 3: Community Information Schema
export const communityInformationSchema = z.object({
  typeOfCommunity: z.string().min(1, "Type of community managed is required"),
  communitySize: z.string().min(1, "Community size is required"),
  communityTalent: z.array(z.nativeEnum(CommunityTalent)).min(1, {
    message: "Please select at least one community talent",
  }),
  majorChallenges: z.string().min(1, "Major challenges is required"),
  digitalToolsUsed: z.string().optional(),
});

export enum PreferredSalesConversationTime {
  MORNING = "morning",
  AFTERNOON = "afternoon",
  EVENING = "evening",
}

// Step 4: Sales Conversation Preference Schema
export const salesConversationPreferenceSchema = z.object({
  preferredSalesConversationDate: z.date({
    required_error: "Please select your preferred conversation date",
    invalid_type_error: "Please enter a valid date",
  }).min(new Date(), "Conversation date must be in the future"),
  preferredSalesConversationTime: z.nativeEnum(PreferredSalesConversationTime, {
    errorMap: () => ({ message: "Please select your preferred conversation time" }),
  }),
});

export const communitySalesConversationSchema = companyInformationSchema
  .merge(contactDetailsSchema)
  .merge(communityInformationSchema)
  .merge(salesConversationPreferenceSchema);

export type CompanyInformationFormData = z.infer<
  typeof companyInformationSchema
>;
export type ContactDetailsFormData = z.infer<typeof contactDetailsSchema>;
export type CommunityInformationFormData = z.infer<typeof communityInformationSchema>;
export type SalesConversationPreferenceFormData = z.infer<typeof salesConversationPreferenceSchema>;
export type CommunitySalesConversationFormData = z.infer<typeof communitySalesConversationSchema>;
